export default {"src":"/_next/static/media/earn-step-3.f1e83ec9.svg","height":710,"width":803,"blurWidth":0,"blurHeight":0};